import * as fromDatatype from '../datatype-library/index';

export interface app_mst_custom_field_value_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  cf_item_guid: fromDatatype.GuidDataFieldInterface;
  cf_item_association: fromDatatype.VarcharDatatypeInterface;
  ref_type: fromDatatype.VarcharDatatypeInterface;
  ref_table: fromDatatype.VarcharDatatypeInterface;
  ref_column: fromDatatype.TextDatatypeInterface;
  ref_row: fromDatatype.VarcharDatatypeInterface;
  value_type: fromDatatype.TextDatatypeInterface;
  value_string: fromDatatype.TextDatatypeInterface;
  value_file: fromDatatype.VarcharDatatypeInterface;
  value_numeric: fromDatatype.NumericDatatypeInterface;
  value_datetime: fromDatatype.TimestampTzDatatypeInterface;
  value_json: any;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class app_mst_custom_field_value_RowClass implements app_mst_custom_field_value_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  cf_item_guid: fromDatatype.GuidDataFieldInterface;
  cf_item_association: fromDatatype.VarcharDatatypeInterface;
  ref_type: fromDatatype.VarcharDatatypeInterface;
  ref_table: fromDatatype.VarcharDatatypeInterface;
  ref_column: fromDatatype.TextDatatypeInterface;
  ref_row: fromDatatype.VarcharDatatypeInterface;
  value_type: fromDatatype.TextDatatypeInterface;
  value_string: fromDatatype.TextDatatypeInterface;
  value_file: fromDatatype.VarcharDatatypeInterface;
  value_numeric: fromDatatype.NumericDatatypeInterface;
  value_datetime: fromDatatype.TimestampTzDatatypeInterface;
  value_json: any;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}


